import './CommentsContainer.css'
import ReactDOM from 'react-dom'
import React, { useEffect, useRef } from 'react'
import CommentGroup from './CommentGroup'

// TODO: Because this seems like mostly a pass-through component
//   it might be a good candidate for refactoring away

export default function CommentsContainer({
  annotation,
  annotationId,
  canEdit,
  commentReplies,
  commentsContainerRef,
  iconColor,
  isAnnotatable,
  isCommenting,
  isSelected,
  isVisible = true,
  managedTop,
  onCommentBlur,
  onCommentEscape = () => {},
  onCommentFocus = () => {},
  onCommentGroupBlur,
  onCommentGroupHeightChange,
  onCommentGroupUnmount,
  onCommentSave,
  onDeleteAnnotation,
  onDeletePopupCancel = () => {},
  onDeletePopupConfirm = () => {},
  onHoverAnnotation,
  onSelectComment = () => {},
  rect,
  sessionUserObject,
  shouldCommentGroupStack = false,
}) {
  const div = useRef(null)

  useEffect(() => {
    return () => {
      if (onCommentBlur) {
        onCommentBlur()
      }
    }
  }, [])

  const hasComment = commentReplies && commentReplies.length > 0
  const isCommentableAndSelected = canEdit && isSelected
  const showCommentGroup =
    hasComment || isCommenting || isCommentableAndSelected || annotation.deleted

  const component = (
    <div className="CommentsContainer" onBlur={onCommentBlur} onFocus={onCommentFocus} ref={div}>
      <div className="CommentsContainer-inside" style={{}}>
        {showCommentGroup && (
          <CommentGroup
            annotation={annotation}
            annotationId={annotationId}
            // canDelete={canDelete}
            canEdit={canEdit}
            shouldCommentGroupStack={shouldCommentGroupStack}
            commentReplies={commentReplies}
            iconColor={iconColor}
            isAnnotatable={isAnnotatable}
            isCommenting={isCommenting}
            isSelected={isSelected}
            isVisible={isVisible}
            key={annotationId}
            managedTop={managedTop}
            onCommentEscape={onCommentEscape}
            onCommentGroupBlur={onCommentGroupBlur}
            onCommentGroupHeightChange={onCommentGroupHeightChange}
            onCommentGroupUnmount={onCommentGroupUnmount}
            onCommentSave={onCommentSave}
            onDeleteAnnotation={onDeleteAnnotation}
            onDeletePopupCancel={onDeletePopupCancel}
            onDeletePopupConfirm={onDeletePopupConfirm}
            onHoverAnnotation={onHoverAnnotation}
            onSelectComment={onSelectComment}
            sessionUserObject={sessionUserObject}
            top={rect[1][1]}
          />
        )}
      </div>
    </div>
  )

  return ReactDOM.createPortal(component, commentsContainerRef.current)
}
